import logoCogas from 'assets/img/logos-feature/logo-cogas.png';
import logoCtpc from 'assets/img/logos-feature/logo-ctpc.png';
import logoTm from 'assets/img/logos-feature/logo-tm.jpg';
import logoTouloisirs from 'assets/img/logos-feature/logo-touloisirs.jpg';

export const getSubTypeLogo = (subType) => {
  if (!subType) return null;

  subType = subType.toLowerCase();

  switch (subType) {
    case 'cogas':
      return logoCogas;
    case 'smile':
      return logoTouloisirs;
    case 'purplecogasico':
    case 'ctpc':
      return logoCtpc;
    case 'tmi':
      return logoTm;
    default:
      return null;
  }
};
